import TeFile from './index.vue';


TeFile.install = function(Vue) {
  Vue.component(TeFile.name, TeFile);
};

export default TeFile;